import {queries} from '@/shared/integrations/zero'
import {useQuery, useSuspenseQuery} from '@rocicorp/zero/react'

export function useGetUser(id: string | undefined | null) {
  return useQuery(queries.users.getUserById(id || ''))
}

export function useSuspenseGetUser(id: string | undefined | null) {
  return useSuspenseQuery(queries.users.getUserById(id || ''), {enabled: Boolean(id)})
}
